import React from "react";
import { IonGrid, IonRow, IonCol, IonSpinner } from "@ionic/react";
import { PieChart } from "react-feather"; // ikon kecil di pojok kanan atas

interface StatisticsData {
    inPicker: number;
    outPicker: number;
    remainingPicker: number;
    inChecker: number;
    outChecker: number;
    remainingChecker: number;
    inPacking: number;
    inPackingFlashsale: number;
    totalShipments: number;
}

interface StatisticsCardProps {
    data?: StatisticsData | null;
    loading?: boolean;
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({ data, loading }) => {
    const stats = [
        { label: "Picker In", value: data?.inPicker ?? 0, color: "#1ABC9C" },
        { label: "Picker Out", value: data?.outPicker ?? 0, color: "#1ABC9C" },
        { label: "Sisa Picker", value: data?.remainingPicker ?? 0, color: "#1ABC9C", full: true },
        { label: "Checker In", value: data?.inChecker ?? 0, color: "#2ECC71" },
        { label: "Checker Out", value: data?.outChecker ?? 0, color: "#2ECC71" },
        { label: "Sisa Checker", value: data?.remainingChecker ?? 0, color: "#2ECC71", full: true },
        { label: "Packing", value: data?.inPacking ?? 0, color: "#3498DB" },
        { label: "Packing Flashsale", value: data?.inPackingFlashsale ?? 0, color: "#9B59B6" },
        { label: "Total Resi", value: data?.totalShipments ?? 0, color: "#E74C3C", full: true },
    ];

    if (loading && !data) {
        return (
            <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
                <IonSpinner name="crescent" />
            </div>
        );
    }

    return (
        <IonGrid>
            <IonRow>
                {stats.map((item, index) => (
                    <IonCol size={item.full && item.full === true ? '12': '6'} sizeMd="4" key={index} style={{ marginBottom: item.full && item.full === true ? '15px' : '0' }}>
                        <div
                            style={{
                                backgroundColor: item.color,
                                borderRadius: "12px",
                                padding: "16px",
                                color: "white",
                                position: "relative",
                                minHeight: "90px",
                                //boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            }}
                        >
                            {/* Icon pojok kanan atas */}
                            <PieChart
                                size={18}
                                color="white"
                                style={{ position: "absolute", top: "12px", right: "12px", opacity: 0.8 }}
                            />

                            {/* Value utama */}
                            <div
                                style={{
                                    fontSize: "1.6rem",
                                    fontWeight: "bold",
                                    marginTop: "10px",
                                }}
                            >
                                {item.value}
                            </div>

                            {/* Label kecil di bawah */}
                            <div
                                style={{
                                    fontSize: "0.9rem",
                                    opacity: 0.9,
                                }}
                            >
                                {item.label}
                            </div>
                        </div>
                    </IonCol>
                ))}
            </IonRow>
        </IonGrid>
    );
};

export default StatisticsCard;
